import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueRouter from 'vue-router'
import { routes } from './routes';
import VueTheMask from 'vue-the-mask';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import './assets/js/custom';
import './registerServiceWorker'

require('./components/');

Vue.use(VueRouter);
const router = new VueRouter({ 
  routes: routes,
  base: '/',
  mode: 'history'
});

Vue.use(VueTheMask);
Vue.use(VueSweetalert2);

Vue.config.productionTip = false;

new Vue({
  vuetify,
  router: router,
  render: h => h(App)
}).$mount('#app')
